import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Disabled, DisabledOutlineButton } from "../../../../Constant";
import { DISABLE_BUTTONS_LIST, DISABLE_OUTLINE_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { Btn } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const DisabledOutlineButtons = () => {
    return (
        <Card>
          <CommonCardHeader title={DisabledOutlineButton} span={DISABLE_OUTLINE_BUTTONS} />
          <CardBody className="btn-showcase">
            <Btn disabled outline color="primary">{Disabled}</Btn>
            {DISABLE_BUTTONS_LIST.map((data, index) => (
              <CommonButton key={index} item={data} disabled={true} outline={true}/>
            ))}
          </CardBody>
        </Card>
      );
};

export default DisabledOutlineButtons;
